import { render, staticRenderFns } from "../../../scrum/components/TrackerDataTable/TrackerDataTableItemEdit/TrackerDataTableItemEdit.html?vue&type=template&id=de9e9654&scoped=true&external"
import script from "./PropositionTableEdit.js?vue&type=script&lang=js&external"
export * from "./PropositionTableEdit.js?vue&type=script&lang=js&external"
import style0 from "../../../scrum/components/TrackerDataTable/TrackerDataTableItemEdit/TrackerDataTableItemEdit.css?vue&type=style&index=0&id=de9e9654&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de9e9654",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VSpacer})
